

<template>
  <br>
  <p class="fw-bold">دارایی ها</p>

  <div class="d-flex  mb-2 w-100 justify-content-evenly">

    <div class="  d-flex flex-column">
      <label class="text-end">عنوان</label>
      <input type="text" class="form-control">
    </div>
    <div class="  d-flex flex-column">
      <label class="text-end">کد</label>
      <input type="text" class="form-control">
    </div>
    <div class="  d-flex flex-column">
      <label class="text-end">ماهیت حساب</label>
      <select name="" class="form-control form-select" style="width: 10vw;;" id="">
        <option value="">افزایشی</option>
      </select>    </div>
    <button style="margin-top: 1.3vw;" class="btn btn-primary btn-submit-1">ثبت</button>
  </div>
  <center>
    <table class="table table-striped" style="width: 60vw;" >
      <thead>
      <tr>
        <th style="width: 1vw;"> </th>
        <th>کد  </th>
        <th>عنوان  </th>
        <th>ماهیت حساب  </th>
        <th style="width: 8vw;">عملیات</th>
      </tr>
      </thead>
      <tbody>
      <tr  style="background-color:#5E67FC;">
        <td scope="row" style="color: white !important; font-size: 1vw">+</td>
        <td></td>
        <td></td>
        <td></td>



        <td>
          <a @click.prevent="editMethod( )" href="#"><img class="table-edit-img" src="/img/pen.6428fd02.svg" alt="edit"></a>
          <a @click.prevent="deleteItemModal " href="#"><img class="table-delete-img mx-2"  src="/img/delete.f9fc94bc.svg" alt="delete"></a>
        </td>
      </tr>

      </tbody>
    </table>
  </center>

</template>
<script  >

</script>
<style scoped>
label{
  font-size: .8vw;
}
</style>